import HttpClient from "./axios-helper/HttpClient";

export const getTheme = async (id) => {
    let headers = {
        'Content-Type': "application/json;",
    }

    try {
        const res = await HttpClient.get(`GetThemeDetails/${id}`, headers);
        return res;
    } catch {
        // Unknown/invalid tenant code — send the user to the same generic
        // "page not found" screen as a mistyped URL, so the two cases are
        // indistinguishable (no way to probe which codes exist).
        window.location = "/Error/NotFound";
    }
};